var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00007 2.75584V5.13679L5.71436 6.32726M9.28578 5.13679C9.28578 7.50374 7.36702 9.4225 5.00007 9.4225C2.63314 9.4225 0.714355 7.50374 0.714355 5.13679C0.714355 2.76986 2.63314 0.851074 5.00007 0.851074C7.36702 0.851074 9.28578 2.76986 9.28578 5.13679Z",
    stroke: "#656E8D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2d2c7a4a036646d169409b6c82741a0e.svg";
export { ForwardRef as ReactComponent };